(function () {

  var FIELD_LIMITS = {
    Nombre: 50,
    Apellidos: 50,
    Nacionalidad: 50,
    Frase: 150,
    Fecha: 50
  };

  function sanitize(value, maxLength) {
    if (typeof value !== 'string') return '';
    return value
      .replace(/<script[^>]*>.*?<\/script>/gi, '')
      .replace(/<[^>]+>/g, '')
      .trim()
      .substring(0, maxLength || 100);
  }

  function getMaxLength(propertyName) {
    var base = propertyName.replace(/\d+$/, '');
    return FIELD_LIMITS[base] || 100;
  }

  // Shopify serializes file upload properties as objects {url, name, type, size}.
  // Normalize them to plain strings so /cart/change.js accepts them.
  function normalizePropertyValue(value) {
    if (value === null || value === undefined) return '';
    if (typeof value === 'object' && value.url) return value.url;
    return String(value);
  }

  function getContainerContext(container) {
    var editBtns = container.querySelectorAll('.cart-pef__edit-trigger');
    var actionBar = container.querySelector('.cart-pef__action-bar');
    return { editBtns: editBtns, actionBar: actionBar };
  }

  function enterEditMode(container, editBtns, actionBar) {
    container.querySelectorAll('details.cart-item-card__passport').forEach(function (d) {
      d.open = true;
    });
    container.querySelectorAll('.cart-pef__view').forEach(function (el) {
      el.classList.add('cart-pef__hidden');
    });
    container.querySelectorAll('.cart-pef__edit').forEach(function (el) {
      el.classList.remove('cart-pef__hidden');
    });
    if (editBtns) editBtns.forEach(function (b) { b.classList.add('cart-pef__hidden'); });
    if (actionBar) actionBar.classList.remove('cart-pef__hidden');
    clearError(container);
  }

  function exitEditMode(container, editBtns, actionBar) {
    container.querySelectorAll('.cart-pef__input, .cart-pef__select').forEach(function (el) {
      if (el.dataset.original !== undefined) {
        el.value = el.dataset.original;
      }
    });
    container.querySelectorAll('.cart-pef__view').forEach(function (el) {
      el.classList.remove('cart-pef__hidden');
    });
    container.querySelectorAll('.cart-pef__edit').forEach(function (el) {
      el.classList.add('cart-pef__hidden');
    });
    if (editBtns) editBtns.forEach(function (b) { b.classList.remove('cart-pef__hidden'); });
    if (actionBar) actionBar.classList.add('cart-pef__hidden');
    clearError(container);
  }

  function storeOriginalValues(container) {
    container.querySelectorAll('.cart-pef__input, .cart-pef__select').forEach(function (el) {
      el.dataset.original = el.value;
    });
  }

  function showError(container, message) {
    var errorEl = container.querySelector('.cart-pef__error');
    if (errorEl) errorEl.textContent = message;
  }

  function clearError(container) {
    var errorEl = container.querySelector('.cart-pef__error');
    if (errorEl) errorEl.textContent = '';
  }

  function setSaving(container, actionBar, isSaving) {
    var saveBtn = container.querySelector('.cart-pef__save-trigger');
    var cancelBtn = container.querySelector('.cart-pef__cancel-trigger');
    if (saveBtn) {
      saveBtn.disabled = isSaving;
      saveBtn.textContent = isSaving ? 'Guardando...' : 'Guardar';
    }
    if (cancelBtn) cancelBtn.disabled = isSaving;
  }

  function buildUpdatedProperties(container) {
    var existingPropsRaw = container.dataset.itemProperties || '{}';
    var properties = {};
    try {
      var parsed = JSON.parse(existingPropsRaw);
      if (Array.isArray(parsed)) {
        // Shopify Liquid serializes item.properties as [[key, value], ...] pairs
        parsed.forEach(function (pair) {
          if (Array.isArray(pair) && pair.length >= 2) {
            properties[pair[0]] = normalizePropertyValue(pair[1]);
          }
        });
      } else {
        Object.keys(parsed).forEach(function (key) {
          properties[key] = normalizePropertyValue(parsed[key]);
        });
      }
    } catch (e) {
      properties = {};
    }

    // Read image URLs directly from the DOM — more reliable than JSON serialization
    container.querySelectorAll('img[data-property]').forEach(function (img) {
      var propertyName = img.dataset.property;
      if (propertyName && img.src) {
        properties[propertyName] = img.src;
      }
    });

    // Override text/select fields with sanitized edited values
    container.querySelectorAll('.cart-pef__input, .cart-pef__select').forEach(function (el) {
      var propertyName = el.dataset.property;
      if (!propertyName) return;
      properties[propertyName] = sanitize(el.value, getMaxLength(propertyName));
    });

    return properties;
  }

  function updateViewValues(container, updatedProperties) {
    for (var i = 1; i <= 4; i++) {
      var nombreVal = updatedProperties['Nombre' + i] || '';
      var apellidosVal = updatedProperties['Apellidos' + i] || '';
      var fullName = (nombreVal + ' ' + apellidosVal).trim() || '-';

      var nombreInput = container.querySelector('[data-property="Nombre' + i + '"]');
      if (nombreInput) {
        var fieldEl = nombreInput.closest('.cart-item-card__field');
        if (fieldEl) {
          var viewSpan = fieldEl.querySelector('.cart-pef__view');
          if (viewSpan) viewSpan.textContent = fullName;
        }
      }

      ['Nacionalidad', 'Frase', 'Fecha', 'Modalidad', 'Color'].forEach(function (field) {
        var input = container.querySelector('[data-property="' + field + i + '"]');
        if (!input) return;
        var fieldEl = input.closest('.cart-item-card__field');
        if (!fieldEl) return;
        var viewSpan = fieldEl.querySelector('.cart-pef__view');
        if (!viewSpan) return;
        var newVal = updatedProperties[field + i] || '';
        if (field === 'Frase') {
          viewSpan.textContent = newVal ? '"' + newVal + '"' : '-';
        } else {
          viewSpan.textContent = newVal || '-';
        }
      });
    }

    // Keep stored properties in sync for subsequent edits
    container.dataset.itemProperties = JSON.stringify(updatedProperties);
    container.querySelectorAll('.cart-pef__input, .cart-pef__select').forEach(function (el) {
      el.dataset.original = el.value;
    });
  }

  async function savePassportEdit(container, editBtns, actionBar) {
    var itemLine = parseInt(container.dataset.itemLine, 10);
    if (!itemLine) return;

    setSaving(container, actionBar, true);
    clearError(container);

    var properties = buildUpdatedProperties(container);

    try {
      var response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: itemLine, properties: properties })
      });

      if (!response.ok) {
        throw new Error('HTTP ' + response.status);
      }

      await response.json();
      updateViewValues(container, properties);
      exitEditMode(container, editBtns, actionBar);
    } catch (e) {
      showError(container, 'Error al guardar. Por favor, inténtalo de nuevo.');
    } finally {
      setSaving(container, actionBar, false);
    }
  }

  // Event delegation on document — works for both the page cart and the drawer
  // after AJAX re-renders (drawer replaces innerHTML, which destroys direct listeners).
  document.addEventListener('click', function (e) {
    // Edit trigger
    var editTrigger = e.target.closest('.cart-pef__edit-trigger');
    if (editTrigger) {
      e.preventDefault();
      var card = editTrigger.closest('.cart-item-card');
      var container = card ? card.querySelector('[data-passport-item]') : null;
      if (!container) return;
      storeOriginalValues(container);
      var ctx = getContainerContext(container);
      enterEditMode(container, ctx.editBtns, ctx.actionBar);
      return;
    }

    // Cancel trigger
    var cancelTrigger = e.target.closest('.cart-pef__cancel-trigger');
    if (cancelTrigger) {
      var container = cancelTrigger.closest('[data-passport-item]');
      if (!container) return;
      var ctx = getContainerContext(container);
      exitEditMode(container, ctx.editBtns, ctx.actionBar);
      return;
    }

    // Save trigger
    var saveTrigger = e.target.closest('.cart-pef__save-trigger');
    if (saveTrigger) {
      var container = saveTrigger.closest('[data-passport-item]');
      if (!container) return;
      var ctx = getContainerContext(container);
      savePassportEdit(container, ctx.editBtns, ctx.actionBar);
    }
  });

  // ---- Extra item badges (stickers, linterna) ----
  function addExtraBadges() {
    document.querySelectorAll('.cart-item__name.cart-item-card__title').forEach(function(link) {
      var href = link.getAttribute('href') || '';
      if (href.indexOf('sticker') === -1 && href.indexOf('linterna') === -1) return;
      if (link.previousElementSibling && link.previousElementSibling.classList.contains('cart-item-card__extra-badge')) return;
      var badge = document.createElement('span');
      badge.className = 'cart-item-card__extra-badge';
      badge.textContent = '✶ EXTRA';
      link.insertAdjacentElement('beforebegin', badge);
    });
  }

  document.addEventListener('DOMContentLoaded', addExtraBadges);
  var _badgeRaf = null;
  new MutationObserver(function() {
    if (_badgeRaf) return;
    _badgeRaf = requestAnimationFrame(function() { _badgeRaf = null; addExtraBadges(); });
  }).observe(document.body, { childList: true, subtree: true });

})();